<div class="modal-header">
  <div class="modal-title">Change Password</div>

  <button id="chage-password-close-btn" type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true"></span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="changePswdForm" autocomplete="off">
    <div class="row">
      <div class="col-md-12 mb-3">
        <div class="form-group mb-0">
          <label class="label">Old Password</label>
          <input id="change-old-password" type="password" class="input input__blue" placeholder="Old Passowrd"
            formControlName="OLD_PASSWORD" maxlength="50" required>
          <div class="form-text text-danger m-0" *ngIf="checkControlValid('OLD_PASSWORD')">
            <small>Enter old password</small>
          </div>
        </div>
      </div>
      <div class="col-md-12 mb-3">
        <div class="form-group mb-0">
          <label class="label">New Password</label>
          <input id="add-new-password"  type="password" class="input input__blue" placeholder="at least 8 characters"
            formControlName="NEW_PASSWORD" maxlength="50" required>
          <div class="form-text text-danger m-0" *ngIf="checkControlValid('NEW_PASSWORD')">
            <small>Password must be at least 8 characters with at least 1 number and 1 special character (&#64;, $, !, %, *, #, ?, &)</small>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group mb-0">
          <label class="label">Confirm Password</label>
          <input id="confirm-new-password"  type="password" class="input input__blue" placeholder="at least 8 characters"
            formControlName="NEW_CONFIRM_PASSWORD" maxlength="50" required>
          <div class="form-text text-danger m-0" *ngIf="checkControlValid('NEW_CONFIRM_PASSWORD')">
            <small>Password did not match!</small>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button id="change-passoword-cancel" type="button" class="button secondary__button large__button" (click)="cancel()">Cancel</button>
  <button id="change-passoword-save" type="button" class="button primary__button large__button" (click)="update()">Save New Password</button>
</div>
